// extracted by mini-css-extract-plugin
module.exports = {"header":"Tender_header__1GOzp","details":"Tender_details__1uwWo"};